const RISK = [
  { value: 0, text: 'Suspected' },
  { value: 1, text: 'Confirmed' }
];

type RISK = typeof RISK;

export default RISK;
